import React, { useEffect, useMemo, useState } from 'react';
import { CheckCircle, Clock, ClipboardList, Wrench } from 'lucide-react';
import { apiService } from '../services/api';
import { Order } from '../types';

const DashboardPage: React.FC = () => {
  const [orders, setOrders] = useState<Order[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const response = await apiService.searchMyOrders({ page: 1, pageSize: 200 });
        setOrders(response.entity?.items || []);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);

  const stats = useMemo(() => {
    const inProgress = orders.filter((order) => order.orderStatus === 'Service InProgress').length;
    const assigned = orders.filter((order) => order.orderStatus === 'Assigned').length;
    const done = orders.filter((order) => order.orderStatus === 'Service Done' || order.orderStatus === 'Payment Received').length;

    return [
      { label: 'Assigned Orders', value: orders.length, icon: ClipboardList },
      { label: 'Pending Start', value: assigned, icon: Clock },
      { label: 'In Progress', value: inProgress, icon: Wrench },
      { label: 'Completed', value: done, icon: CheckCircle },
    ];
  }, [orders]);

  return (
    <div>
      <div className="page-heading">
        <div>
          <h1>Dashboard</h1>
          <p>Your assigned repair workload.</p>
        </div>
      </div>

      <div className="stats-grid">
        {stats.map((stat) => {
          const Icon = stat.icon;
          return (
            <div className="stat-card" key={stat.label}>
              <div className="stat-icon"><Icon size={20} /></div>
              <div className="stat-value">{loading ? '-' : stat.value}</div>
              <div className="stat-label">{stat.label}</div>
            </div>
          );
        })}
      </div>

      <div className="content-card">
        <div className="card-header">
          <div>
            <h2>Recent Orders</h2>
            <p>Latest orders assigned to you.</p>
          </div>
        </div>
        <div className="compact-list">
          {orders.slice(0, 6).map((order) => (
            <div className="compact-row" key={order.id}>
              <div>
                <strong>{order.orderNumber}</strong>
                <span>{order.customerName} - {order.makeName} {order.modelName}</span>
              </div>
              <span className="status-pill">{order.orderStatus}</span>
            </div>
          ))}
          {!loading && orders.length === 0 && <div className="empty-state">No assigned orders found.</div>}
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;
